import React from 'react';
import ReactDOMServer from 'react-dom/server';
import MapVehicleIcon from "components/ui/map-vehicle-icon";
import L from 'leaflet';
import './garbage-icon.less'

export default class GarbageIcon {

    static getIcon(type) {
        const html = '';

        let className = 'marker-locality trash';
        switch (type) {
            case 'os':
                className = 'marker-object ts';
                break;
            case 'opp':
                className = 'marker-object kdm';
                break;
            case 'op':
                className = 'marker-object trash';
                break;
        }
        const size = (type !== 'kp') ? [
            70,
            70,
        ] : [
            16,
            16,
        ];
        return new L.DivIcon({
            html: html,
            className: className,
            iconSize: new L.Point(size[0], size[1]),
            iconAnchor: new L.Point(size[0] / 2, size[1] / 2),
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/map/markers/icons/garbage-icon.js